import React from "react";
import { Form, Row } from "react-bootstrap";
import { Col, Input } from "reactstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";

const StatusBar = (props) => {
  const { status, selectedOccurenceType, onOccurencetypeChange } = props;
  const [occurenceTypeValue] = status.filter(
    (_status) => _status.label === selectedOccurenceType
  );
  return (
    <Row className="status-bar">
      <Col lg={4}>
        <Form.Group className="input-Field">
          <Form.Label className="label mr-2">Time Limit 24Hrs</Form.Label>

          <Col>
            <Row>
              <Col className="p-0 px-1 col-5 col-sm-5 col-md-5">
                <Input
                  type="number"
                  name="minutes"
                  min={0}
                  max={12}
                  placeholder="00"
                  autoComplete="off"
                  className="formValueInput pr-2"
                  onChange={props.hourChangeHandler}
                  value={props.hourvalue}
                />
              </Col>
              <Col className="p-0 px-1 col-5 col-sm-5 col-md-5">
                <Input
                  type="number"
                  name="minutes"
                  min={0}
                  max={59}
                  placeholder="00"
                  autoComplete="off"
                  className="formValueInput pr-2"
                  value={props.minutevalue}
                  onChange={props.minutesChangeHanlder}
                />
              </Col>
            </Row>
          </Col>
        </Form.Group>
      </Col>
      <Col lg={4}>
        <Form.Group className="input-Field">
          <Form.Label className="label">Occurence Limit</Form.Label>
          <Col>
            <Input
              type="number"
              name="minutes"
              placeholder="00"
              autoComplete="off"
              className="formValueInput pr-2"
              value={props.occurenceLimitValue}
              onChange={props.occurenceLimitHandler}
            />
          </Col>
        </Form.Group>
      </Col>
      <Col lg={4}>
        <Form.Group className="input-Field">
          <Form.Label className="label">Occurence Type</Form.Label>
          <Col>
            <CustomReactSelect
              options={status}
              value={occurenceTypeValue}
              onChange={(value) => {
                onOccurencetypeChange(value);
              }}
            />
          </Col>
        </Form.Group>
      </Col>
    </Row>
  );
};

export default StatusBar;
